import { isUtenteSpeciale } from "../../modificaProdotti/permessiProdotto";
import useApriProdottoSolaLettura from "../../modificaProdotti/useApriProdottoSolaLettura";
import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import prodVuoto from '../../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';

function CodiceVSVoceCliccabile2({
  codVS,
  codPS,
  codProd,
  shortName,
  setProductFunction,
  utente,
  tit
}) {

  const { apriProdotto, errore } = useApriProdottoSolaLettura();

    const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    let url;

    if (codVS) {
      url = codVS
    } else {
      url = "NULL"
    }

    if (codPS) {
      url = url+"/"+codPS
    } else {
      url = url+"/"+"NULL"
    }

    if (codProd) {
      url = url+"/"+codProd
    } else {
      url = url+"/"+"NULL"
    }

    if (shortName) {
      url = url+"/"+shortName
    } else {
      url = url+"/"+"NULL"
    }

    if (tit) {
      url = url+"/"+tit
    } else {
      url = url+"/"+"NULL"
    }


    useEffect(() => {
        const getUserMetadata = async () => {
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
        getUserMetadata();
      }, [getAccessTokenSilently, user?.sub]);
    
    
      const handleSubmit = (e) => {
        if (isUtenteSpeciale(utente)) {
          e.preventDefault();
          apriProdotto(codVS, (data) => setProductFunction(data[0]));
          return;
        }
        if (!token) {
          console.warn("sto aspettando un token")
          return;
        }
        if (utente.permessiAPI["update:database"]) {
          fetch(apiUrl + "/prodotti/prodotto/showORcreateIDPS/"+url, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => setProductFunction(data[0] || prodVuoto))
          .then(e.preventDefault())
        }        
      }


    return(
        <>
        <span className="pointer" onClick={handleSubmit}>
            <strong>{codVS}</strong>            
        </span>
        {errore && <span role="alert">{errore}</span>}
        </>
    )
}


export default CodiceVSVoceCliccabile2;



